module.exports = __webpack_public_path__ + "static/media/dallal_f_thumb_even.25f587a3.webp";